import { useMemo, useState } from 'react';
import toast from 'react-hot-toast';

import Select from 'react-select';
import ButtonLoader from './ButtonLoader';

import useDocumentTypes from '../hooks/useDocumentTypes';

const AddRequiredDocumentForm = ({ disabledDocumentTypes = [], onSubmit, isSubmitting, onCloseClicked }) => {
  const { data: documentTypesData, isLoading } = useDocumentTypes({
    page: 1,
    perPage: 1000,
  });

  const [selectedDocumentTypes, setSelectedDocumentTypes] = useState(null);

  const documentTypeOptions = useMemo(() => {
    const documentTypes = documentTypesData?.documentTypes || [];

    return documentTypes
      .filter(documentType => !disabledDocumentTypes.find(ddt => ddt._id === documentType._id))
      .map(documentType => ({ value: documentType._id, label: documentType.name }));
  }, [documentTypesData?.documentTypes, disabledDocumentTypes]);

  const handleSubmit = e => {
    e.preventDefault();

    if (!selectedDocumentTypes) {
      toast.error('Please select at least one document type');
      return;
    }

    onSubmit(selectedDocumentTypes.map(l => l.value));
  }

  return (
    <div className="bg-white rounded-lg shadow-md shadow-ase-blue w-full md:w-[600px]">
      <div className="flex items-center justify-between text-lg border-b bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Add documents</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 py-2 px-4"
      >
        <label className='flex flex-col gap-1'>
          <span>Type</span>

          <Select
            value={selectedDocumentTypes}
            onChange={setSelectedDocumentTypes}
            options={documentTypeOptions}
            isDisabled={isLoading}
            isMulti={true}
          />
        </label>

        <button
          type="submit"
          className="w-full bg-ase-blue text-white font-semibold h-[48px] rounded-md flex items-center justify-center"
        >
          {isSubmitting ? <ButtonLoader /> : 'Add'}
        </button>
      </form>
    </div>
  )
}

export default AddRequiredDocumentForm;
